var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isClose)?_c('MaskLayer',[_c('Slider',{staticClass:"w-25",on:{"close":_vm.close}},[_c('div',{staticClass:"flex-grow-1 overflow-auto bg-gray100"},[_c('McfWriteOff')],1)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }